import React, { Dispatch, SetStateAction } from 'react';
import { DocumentGroup } from 'types/documentGroup';
import { JobOutput } from 'types';
import styled from 'styled-components';
import GroupListItem from './GroupListItem';

interface OwnProps {
  documentGroups: DocumentGroup[];
  documents: JobOutput[];
  onRemove: (groupId: string) => void;
  onUpdate: (documentGroup: DocumentGroup) => void;
  setDocuments: Dispatch<SetStateAction<JobOutput[]>>;
}

const GroupListItems = styled.div`
  margin-top: 5px;
  width: 100%;
`;

const GroupList = ({ documentGroups, documents, onRemove, onUpdate, setDocuments }: OwnProps) => {
  const orderedGroupJobs = [...documentGroups].reverse();
  return (
    <GroupListItems>
      {orderedGroupJobs.length > 0 &&
        orderedGroupJobs.map((groupJob, groupIndex) => {
          const key = `groupJob-${groupIndex}`;
          return (
            <GroupListItem
              documentGroup={groupJob}
              allDocuments={documents}
              setDocuments={setDocuments}
              onRemove={onRemove}
              onUpdate={onUpdate}
              key={key}
            />
          );
        })}
    </GroupListItems>
  );
};

export default React.memo(GroupList);
